import { render } from "./IconBoxes.vue?vue&type=template&id=c20c054a"
import script from "./IconBoxes.vue?vue&type=script&lang=js"
export * from "./IconBoxes.vue?vue&type=script&lang=js"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__